import styled from 'styled-components'

export type StyledDotProps = {
  color?: string
}

export const Tooltip = styled.div`
  padding: 15px 15px 15px 15px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.palette.black[20]};
`

export const Label = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.black[70]} !important;
`

export const Delimiter = styled.div`
  margin-bottom: 5px;
  width: 100%;
  height: 0;
  border-top: 1px solid #49536e;
`

export const Legend = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  color: ${({ theme }) => theme.palette.white};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

export const Dot = styled.div<StyledDotProps>`
  width: 3px;
  height: 20px;
  border-radius: 10px;
  background-color: ${({ color }) => color};
`
